/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react'

import OptionsIcon from 'assets/icons/options-icon'

import { StyledActionsMenu, ActionMenuContainer, ActionMenuDropdownMenuContainer, TestDiv } from './style'
import ActionDropdownMenu from './ActionDropdownMenu'

const ActionsMenu = ({ dropdownItems = [], margin = '0 10px 0 10px', table = true, manageCo = false}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState({top: '100px', left: '100px'})
  const [upward, setUpward] = useState(false)
  const actionDropdownMenu = useRef()

  const closeMenu = () => {
    setIsOpen(false)
  }

  const closeDropDownMenuOnOutsideClick = (e) => {
    if (!actionDropdownMenu.current?.contains(e.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', closeDropDownMenuOnOutsideClick)

    return () => {
      document.removeEventListener('click', closeDropDownMenuOnOutsideClick)
    }
  }, [])

  function openMenu(e) {

    // Estimate dropdown height and decide whether to show above or below
    const ESTIMATED_DROPDOWN_HEIGHT = 240 // px - safe estimate for menu height
    const spaceBelow = window.innerHeight - e.clientY
    const showAbove = spaceBelow < ESTIMATED_DROPDOWN_HEIGHT

    const topCalculated = showAbove ? Math.ceil(e.clientY) - 10 : Math.ceil(e.clientY) + 20
    setPosition({ top: topCalculated, left: e.clientX })
    setUpward(showAbove)

    if (dropdownItems.length) {
      setIsOpen(true)
    }
  }

  return (
    <>
      <ActionMenuContainer data-testid='test-action-menu' ref={actionDropdownMenu} margin={margin}>
        <StyledActionsMenu isActive={isOpen} onClick={openMenu}>
          <OptionsIcon />
        </StyledActionsMenu>
        {/*<TestDiv top={position.top} left={position.left} />*/}
        <ActionMenuDropdownMenuContainer data-testid='test-dropdown-action-menu' position={position} table={table} manageCo={manageCo} active={isOpen} upward={upward}>
          <ActionDropdownMenu closeMenu={closeMenu} dropdownItems={dropdownItems} />
        </ActionMenuDropdownMenuContainer>
      </ActionMenuContainer>
    </>
  )
}

export default ActionsMenu
